module.exports = __webpack_public_path__ + "img/Al-Harith1.27ecfaee.jpg";